export const contactsData = {
    email: 'abubakar003m@gmail.com',
    phone: '+923057165645',
    address: 'Islamabad, Pakistan ',
}